import {Dispatch, SetStateAction} from "react";
import {TaxInvoiceListElementType, TaxInvoiceSearchParamType} from "../interface";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {SubmitHandler, useForm} from "react-hook-form";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker"; // 내부수정: 날짜 일괄 변경

interface PropsType {
    searchParam: TaxInvoiceSearchParamType;
    setSearchParam: Dispatch<SetStateAction<TaxInvoiceSearchParamType>>;
    setSelectedItems: Dispatch<SetStateAction<TaxInvoiceListElementType[]>>
    selectedItems: TaxInvoiceListElementType[] // 내부수정
    issueDate: string // 내부수정
    setIssueDate: Dispatch<SetStateAction<string>> // 내부수정
    btnApplyIssueDate: () => any // 내부수정
}

export default function Filter({searchParam, setSearchParam, setSelectedItems, selectedItems, issueDate, setIssueDate, btnApplyIssueDate}: PropsType) {
    const {goToNavigation} = useGoToNavigation();
    const {register, handleSubmit, watch} = useForm({
        defaultValues: searchParam,
    });

    const onSubmit: SubmitHandler<TaxInvoiceSearchParamType> = (submitData) => {
        goToNavigation(`order/invoice/list?pageNo=1`, {}, false);
        // 내부수정: 키워드 추가
        setSearchParam({...submitData, pageNo: 1, keywordType1: submitData.keyword1 ? "2" : "1", keywordType2: submitData.keyword2 ? "4" : "1"});
        setSelectedItems([])
    };

    // 내부수정: 발행요청 상태(N)인 항목만 선택됐을 때 활성화
    const isBtnApplyIssueDateDisabled = selectedItems.length === 0
        || selectedItems.some(el => el.taxFlag === "Y")

    return (
        <div className="fiter_wrap">
            <div className="fiter_top">
                <h3 className="filter_heading">세금계산서 검색</h3>
                <div className="filter_toolbar"></div>
            </div>
            <form className="row" onSubmit={handleSubmit(onSubmit)}>
                <div className="col-6">
                    <div className="frm_row search justify-content-start">
                        <label className="form-label frm_label">조건</label>
                        <select
                            className="form-select w-150px ms-20px"
                            value={watch("taxFlag")}
                            {...register("taxFlag")}
                        >
                            <option value="0">전체</option>
                            <option value="Y">발행</option>
                            <option value="N">발행 요청</option>
                        </select>
                    
                    <div className="frm_field input_date">
                            <input type="date" className="form-control"
                                value={watch("fromDate")}
                                {...register("fromDate")} />
                            <span className="txt_range">~</span>
                            <input type="date" className="form-control me-0"
                                value={watch("toDate")}
                                {...register("toDate")} />
                        </div>
                    </div>
                    {/* 내부수정: 발행일자 일괄 적용 */}
                    <AuthorityChecker authorityNames={['taxWriteYn']}>
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">일자 일괄 적용</label>
                            <input type="date" className="form-control w-150px"
                                   value={issueDate}
                                   onChange={(e) => setIssueDate(e.target.value)}/>
                            <button type="button" className="btn btn-info btn_search w-80px" onClick={btnApplyIssueDate} disabled={isBtnApplyIssueDateDisabled}>적용</button>
                        </div>
                    </AuthorityChecker>
                </div>
                <div className="col-6">
                     <div className="frm_row">
                        <label htmlFor="" className="form-label frm_label">검색어</label>
                        <input type="text" className="form-control w-100px me-5px" 
                            placeholder="담당자"
                            {...register("keyword1")}/>
                        <input type="hidden" {...register("keywordType1")} />
                        <input type="text" className="form-control w-250px me-5px" 
                            placeholder="매출처"
                            {...register("keyword2")}/>
                        <input type="hidden" {...register("keywordType2")} /> 
                        <button className="btn btn-info btn_search">
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}
